import React from "react";
import NumberFormat from "react-number-format";

const PYG = ({ value, type, ...props }) => (
  <NumberFormat
    value={value}
    displayType={type || "text"}
    thousandSeparator="."
    decimalSeparator=","
    prefix={"Gs. "}
    {...props}
  />
);

export default PYG;
